import { ReferenceData } from './reference-data.model';

export class Frequency extends ReferenceData {

  maintenanceResponsibility: string;
  annualFactor: number;
  useStandardHours: boolean;

  // tslint:disable-next-line:no-any
  constructor(data: any) {
    super(data);
    this.maintenanceResponsibility = data.maintenanceResponsibility;
    this.annualFactor = data.annualFactor;
    this.useStandardHours = data.useStandardHours;
  }
}
